<template>
    <div class="success-info">
        <div class="top">
            <div class="title-box">
                <p class="title">成功案例</p>
            </div>
            <p class="des">未来魔法校已合作机构4500+</p>
        </div>
        <div class="demo-box">
            <div class="demo-item" v-for="(item, index) in dataList" :key="index">
                <p class="school-name">{{item.title}}</p>
                <div class="time-box" :class="{ twoLine: item.isTwo}">
                    <p class="li">合作时间：{{item.time}}</p>
                    <p class="li">合作模式：{{item.mode}}</p>
                </div>
                <p class="des">{{item.content}}</p>
                <br>
                <p class="president">— {{item.author}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import dataList from './data'
export default {
    data () {
        return {
            dataList: dataList
        }
    }
}
</script>
<style lang="scss" scoped>
.success-info{
    .top{
        width: 100%;
        height: 144px;
        padding-top: 40px;
        background: #148AFF;
        color: #ffffff;
        .title-box{
            width: 221px;
            height: 0px;
            border: 0px;
            border-top: 2px dotted #D8D8D8;
            position: relative;
            margin: 0 auto;
            .title{
                font-size:18px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                line-height:25px;
                background: #148AFF;
                padding: 0px 12px;
                position: absolute;
                top: -13px;
                left: 50%;
                transform: translateX(-50%);
            }
        }
        .des{
            font-size:10px;
            font-family:PingFangSC-Regular,PingFang SC;
            font-weight:400;
            line-height:14px;
            margin-top: 20px;
        }
    }
    .demo-box{
        margin-top: -44px;
        padding: 0px 20px; 
        .demo-item{
            padding: 30px 20px 30px 26px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 12px 0px rgba(147,147,147,0.14);
            border-radius:6px;
            margin-bottom: 10px;
            .school-name{
                font-size:14px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(40,40,40,1);
                line-height:24px;
                text-align: left;
            }
            .time-box{
                font-size:12px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(40,40,40,1);
                line-height:14px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                .li{
                    margin-right: 15px;
                    &:last-of-type{
                        margin-right: 0px;
                    }
                }
                &.twoLine{
                    display: block;
                    text-align: left;
                }
            }
            .des{
                margin-top: 20px;
                text-align: left;
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:#282828;
                line-height:22px;
            }
            .president{
                font-size:12px;
                font-family:PingFangSC-Regular,PingFang SC;
                font-weight:400;
                color:#282828;
                line-height:22px;
                text-align: right;
            }
            &:last-of-type{
                margin-bottom: 0px;
            }
        }
    }
}
</style>